import { render, staticRenderFns } from "./TheCallDisposition.vue?vue&type=template&id=5c5ac99f"
import script from "./TheCallDisposition.vue?vue&type=script&lang=js"
export * from "./TheCallDisposition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports